import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { useEffect, useRef, useState } from "react";
import { useBinaryContent } from "@/hooks/binary";
import { decodeBase64Content, fetchDocumentFromUrl } from "./document-content";

/** Return shape of {@link useSelectedDocument}. */

/** Resolves encounter document content (inline or via URL) and tracks viewer state. */
export function useSelectedDocument(workspaceId, patientId) {
  var _useState = useState(null),
    selectedDocument = _useState[0],
    setSelectedDocument = _useState[1];
  var _useState2 = useState(false),
    isOpening = _useState2[0],
    setIsOpening = _useState2[1];
  var binaryContent = useBinaryContent(workspaceId, patientId);
  var blobUrlsRef = useRef([]);
  useEffect(function () {
    return function () {
      blobUrlsRef.current.forEach(function (url) {
        if (url.startsWith("blob:")) URL.revokeObjectURL(url);
      });
    };
  }, []);
  var openDocument = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(document, encounter) {
      var binary, resourceType, resourceId, contentType, result, response;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            binary = document.binary, resourceType = document.resourceType, resourceId = document.resourceId;
            setIsOpening(true);
            _context.p = 1;
            contentType = binary.content_type;
            if (!binary.data) {
              _context.n = 2;
              break;
            }
            result = decodeBase64Content(binary.data, contentType);
            _context.n = 7;
            break;
          case 2:
            _context.n = 3;
            return binaryContent.mutateAsync({
              fhir_id: binary.fhir_id,
              content_type: binary.content_type,
              resource_type: resourceType,
              resource_id: resourceId
            });
          case 3:
            response = _context.v;
            contentType = response.content_type;
            if (!response.data) {
              _context.n = 4;
              break;
            }
            result = decodeBase64Content(response.data, contentType);
            _context.n = 7;
            break;
          case 4:
            if (!response.url) {
              _context.n = 6;
              break;
            }
            _context.n = 5;
            return fetchDocumentFromUrl(response.url, contentType);
          case 5:
            result = _context.v;
            _context.n = 7;
            break;
          case 6:
            throw new Error("No document content available");
          case 7:
            if (result.blobUrl) blobUrlsRef.current.push(result.blobUrl);
            setSelectedDocument({
              name: document.name,
              contentType: contentType,
              htmlContent: result.htmlContent,
              url: result.blobUrl,
              encounter: encounter
            });
          case 8:
            _context.p = 8;
            setIsOpening(false);
            return _context.f(8);
          case 9:
            return _context.a(2);
        }
      }, _callee, null, [[1,, 8, 9]]);
    }));
    return function openDocument(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    selectedDocument: selectedDocument,
    closeDocument: function closeDocument() {
      return setSelectedDocument(null);
    },
    isOpening: isOpening,
    openDocument: openDocument
  };
}